import _ from 'lodash'
import apiService from 'apiService'
import React, { useEffect, useState } from 'react'
import Select from 'react-select'

export default function SingleStoreSelect({ handler, width = '12' }) {
    const [stores, setStores] = useState([])

    const getStores = async () => {
        const stores = await apiService.get('/stores')
        if (stores === null) return
        stores.map(el => {
            el.label = el.name.toUpperCase()
            el.value = el.id
        })
        setStores(stores)
    }

    const handleChange = e => {
        handler(e.id)
    }

    useEffect(() => {
        getStores()
    }, [])

    return (
        <>
            <div className={`w-full lg:w-${width} px-4`}>
                <div className="relative w-full mb-3">
                    <label className="block uppercase text-blueGray-600 text-xs font-bold mb-2">ΚΑΤΑΣΤΗΜΑ</label>
                    <Select options={stores} placeholder="Επιλέξτε κατάστημα" onChange={handleChange} />
                </div>
            </div>
        </>
    )
}
